import { render } from "./BatteryDisplay.vue?vue&type=template&id=f4a5d9fa"
import script from "./BatteryDisplay.vue?vue&type=script&lang=js"
export * from "./BatteryDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__